import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Eye } from "lucide-react";
import { ProductPlanificationListItem } from "@/pages/ata-rsa-production/product-planification/schema/product-planification.schema";

interface Props {
  item: ProductPlanificationListItem;
  handleDetail: (id: any) => void;
}

export const ProductPlanificationActionElements = ({ handleDetail, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Ver detalle</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <Eye cursor="pointer" onClick={() => handleDetail(item?.id)} />
      </Flex>
    </Tooltip>
  );
};
